<div class="tam-contact-control">
    <textarea class="tam-input" [style.width.px]="childConfig.css.width" [style.height.px]="childConfig.css.height"
        [(ngModel)]="inputValue" (ngModelChange)="textChange($event)" [maxLength]='config.maxLength||2048'></textarea>
</div>